import { render, staticRenderFns } from "./headerexpire_promotion.vue?vue&type=template&id=3e5b5dfa&scoped=true&"
import script from "./headerexpire_promotion.vue?vue&type=script&lang=js&"
export * from "./headerexpire_promotion.vue?vue&type=script&lang=js&"
import style0 from "./headerexpire_promotion.vue?vue&type=style&index=0&id=3e5b5dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b5dfa",
  null
  
)

export default component.exports